import React from 'react';
import { useTranslation } from 'react-i18next';
import { BodyText, Button, Div, Flex, Gutter } from '@gaiads/telia-react-component-library';
import { getSKUsCountByListItems } from '../../utils/products';
import { ProductsListItem } from './ProductList/ProductsList';

interface BottomDrawerProps {
  selectedProducts: ProductsListItem[];
  setSelectedProducts: React.Dispatch<React.SetStateAction<ProductsListItem[]>>;
  moveToProductDetail: (product: ProductsListItem) => void;
  handleRemoveProducts: () => void;
  resetSelections: () => void;
}

const BottomDrawer = ({ selectedProducts, setSelectedProducts, moveToProductDetail, handleRemoveProducts, resetSelections }: BottomDrawerProps) => {
  const { t } = useTranslation('productsscreen');

  const EditButton = () => (
    <Button
      variant={'primaryWhite'}
      onClick={() => {
        setSelectedProducts([]);
        moveToProductDetail(selectedProducts[0]);
      }}
    >
      {t('selected.editProduct')}
    </Button>
  );
  const selectedProductCount = getSKUsCountByListItems(selectedProducts);

  return (
    <div className="sticky-footer">
      <Div margin={{ horizontal: 'xxlg', vertical: 'md' }}>
        <Flex padding={{ horizontal: 'md' }}>
          <Flex flexItem alignBaseline spaceBetween>
            <Flex flexItem alignBaseline>
              <BodyText color={'white'}>{t('selected.skuSelected', { count: selectedProductCount })}</BodyText>
              <Gutter />
              {selectedProducts.length === 1 && <EditButton />}
              <Gutter />
              <Button onClick={() => handleRemoveProducts()} variant={'destructive'}>
                {t('selected.delete')}
              </Button>
              <Flex />
              <Flex flexItem alignBaseline alignRight>
                <Button textVariantProps={{ color: 'white' }} size={'xl'} onClick={() => resetSelections()} variant={'text'}>
                  {t('selected.cancel')}
                </Button>
              </Flex>
            </Flex>
          </Flex>
        </Flex>
      </Div>
    </div>
  );
};

export default BottomDrawer;
